import { PlatformType } from "./models";

const VITE_ENV = import.meta.env;

export const ENV = VITE_ENV.REACT_APP_NODE_ENV;
export const APP_PREFIX = VITE_ENV.REACT_APP_PREFIX;
export const DD_CLIENT_TOKEN = VITE_ENV.REACT_APP_DD_CLIENT_TOKEN;
export const DD_SERVICE = VITE_ENV.REACT_APP_DD_SERVICE;
export const BACKEND_BASE_URL = VITE_ENV.REACT_APP_BACKEND_BASE_URL;
export const ANALYTIC_BASE_URL = VITE_ENV.REACT_APP_ANALYTIC_BASE_URL;
export const WIDGET_EDITOR_URL = VITE_ENV.REACT_APP_WIDGET_EDITOR_URL;
export const MAX_SLOT = +(VITE_ENV.REACT_APP_MAX_SLOT || 10);
export const APP_PLATFORM = VITE_ENV.REACT_APP_PLATFORM as PlatformType;
export const CRISP_WEBSITE_ID = VITE_ENV.REACT_APP_CRISP_WEBSITE_ID;
export const SHOPIFY_API_KEY = VITE_ENV.REACT_APP_SHOPIFY_API_KEY;
export const SHOPIFY_APP_ID = VITE_ENV.REACT_APP_SHOPIFY_APP_ID;
export const DEFAULT_SLOT_STORE_TEMPLATE = VITE_ENV.REACT_APP_DEFAULT_SLOT_STORE_TEMPLATE;
export const SHOPIFY_RECONVERT_THEME_APP_EXTENSION_ID =
    VITE_ENV.REACT_APP_SHOPIFY_RECONVERT_THEME_APP_EXTENSION_ID;
export const UNLEASH_URL = VITE_ENV.REACT_APP_UNLEASH_URL;
export const UNLEASH_CLIENT_KEY = VITE_ENV.REACT_APP_UNLEASH_CLIENT_KEY;
export const UNLEASH_REFRESH_INTERVAL = VITE_ENV.REACT_APP_UNLEASH_REFRESH_INTERVAL;
export const UNLEASH_ENABLE_REVIEW_COLLECTOR = 'review-collector';

// Review collector config
export const REVIEW_BASE_URL = VITE_ENV.REACT_APP_REVIEW_BASE_URL;
export const REVIEW_INTERVAL_IN_MIN = VITE_ENV.REACT_APP_REVIEW_INTERVAL_IN_MIN;
export const IS_REVIEW_DISMISSABLE = VITE_ENV.REACT_APP_IS_REVIEW_DISMISSABLE === "true";
export const APP_STORE_URL = VITE_ENV.REACT_APP_APP_STORE_URL;
export const CHECKOUT_API_BASE_URL = VITE_ENV.REACT_APP_CHECKOUT_API;
export const REVIEW_COLLECTOR_DISABLED = VITE_ENV.REACT_APP_REVIEW_COLLECTOR_DISABLED;
export const RECONVERT_IO_URL = VITE_ENV.REACT_APP_RECONVERT_IO_URL;
export const STICKY_REVIEW_INTERVAL_IN_MIN = VITE_ENV.REACT_APP_STICKY_REVIEW_INTERVAL_IN_MIN;
export const RECONVERT_IO_HELP_URL = VITE_ENV.REACT_APP_RECONVERT_IO_HELP_URL;

// Billing subscriber config
export const LATEST_PLAN_ID = VITE_ENV.REACT_APP_LATEST_PLAN_ID;
export const LATEST_PLAN_MAX_CAP = VITE_ENV.REACT_APP_LATEST_PLAN_MAX_CAP;

// Book demo banner config
export const BOOK_DEMO_BANNER_MAX_CAP =
    VITE_ENV.REACT_APP_BOOK_DEMO_BANNER_MAX_CAP;
export const BOOK_DEMO_BANNER_CALENDLY_URL = VITE_ENV.REACT_APP_BOOK_DEMO_BANNER_CALENDLY_URL;
export const UNLEASH_DISABLE_APP_BRIDGE_MODAL = 'disable-app-bridge-modal';
export const UNLEASH_SHOW_BOOK_DEMO_BANNER_FORCEFULLY = 'show-book-demo-banner-forcefully';
export const CLARITY_PROJECT_ID = VITE_ENV.REACT_APP_CLARITY_PROJECT_ID;

// Mantle help desk config
export const MANTLE_HELP_DESK_WIDGET_ID = VITE_ENV.REACT_APP_MANTLE_HELP_DESK_WIDGET_ID;
export const MANTLE_HELP_DESK_SCRIPT_URL = VITE_ENV.REACT_APP_MANTLE_HELP_DESK_SCRIPT_URL;
